import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import { ButtonProps } from './types';

const AddButton: React.FC<ButtonProps> = (props) => {
    return (
        <Tooltip title={props.label || ''}>
            <Fab
                size={props.size || 'medium'}
                color={props.color || 'primary'}
                aria-label={props.label}
                onClick={() => {
                    props.action();
                }}
                className="add-button"
            >
                <AddIcon />
            </Fab>
        </Tooltip>
    );
};

export default AddButton;
